export default __webpack_public_path__ + "static/media/flower_3000.df5a94da.jpg";